import { StoreModal } from '../../Types/StoreTypes';

export const SET_THEME_MODAL_STATE = 'SET_THEME_MODAL_STATE';
export const SET_DEMO_MODAL_STATE = 'SET_DEMO_MODAL_STATE';
export const SET_FILE_DLP_MODAL_STATE = 'SET_FILE_DLP_MODAL_STATE';
export const SET_MODAL = 'SET_MODAL';

export function setThemeModalState(themeModalState: StoreModal['themeModalState']) {
    return { type: SET_THEME_MODAL_STATE, payload: themeModalState };
}

export function setDemoModalState(state: StoreModal['demoModalState']) {
    localStorage.setItem('demoModalState', state);
    return { type: SET_DEMO_MODAL_STATE, payload: state };
}

export function setFileDlpModalState(state: StoreModal['fileDlpModalState']) {
    return { type: SET_FILE_DLP_MODAL_STATE, payload: state };
}

export const setModal = (modalData: StoreModal['modal']) => ({
    type: 'SET_MODAL',
    payload: modalData,
});
